import { render, staticRenderFns } from "./PhysicalCardsAdmin.vue?vue&type=template&id=64eb214c&scoped=true"
import script from "./PhysicalCardsAdmin.vue?vue&type=script&lang=js"
export * from "./PhysicalCardsAdmin.vue?vue&type=script&lang=js"
import style0 from "./PhysicalCardsAdmin.vue?vue&type=style&index=0&id=64eb214c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb214c",
  null
  
)

export default component.exports